import { Injectable } from '@angular/core';

import { LookupsService } from 'common';

@Injectable()
export class RegistrationSalutationResolver {
  constructor(private lookupsService: LookupsService) {}

  resolve() {
    return this.lookupsService.getSalutations().toPromise();
  }
}
